import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';
const CheckCircleIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M3.25 6.57329L4.39844 8.20313C4.442 8.2682 4.50047 8.32193 4.56899 8.35984C4.63751 8.39775 4.71409 8.41875 4.79236 8.42109C4.87063 8.42343 4.94833 8.40704 5.01899 8.37329C5.08965 8.33953 5.15122 8.28939 5.19859 8.22704L8.5625 4.00001M0.726562 5.99954C0.726562 6.69206 0.862964 7.3778 1.12798 8.0176C1.39299 8.6574 1.78143 9.23874 2.27112 9.72843C2.7608 10.2181 3.34214 10.6065 3.98194 10.8716C4.62175 11.1366 5.30748 11.273 6 11.273C6.69252 11.273 7.37825 11.1366 8.01806 10.8716C8.65786 10.6065 9.2392 10.2181 9.72888 9.72843C10.2186 9.23874 10.607 8.6574 10.872 8.0176C11.137 7.3778 11.2734 6.69206 11.2734 5.99954C11.2734 5.30702 11.137 4.62129 10.872 3.98149C10.607 3.34168 10.2186 2.76034 9.72888 2.27066C9.2392 1.78097 8.65786 1.39254 8.01806 1.12752C7.37825 0.862506 6.69252 0.726105 6 0.726105C5.30748 0.726105 4.62175 0.862506 3.98194 1.12752C3.34214 1.39254 2.7608 1.78097 2.27112 2.27066C1.78143 2.76034 1.39299 3.34168 1.12798 3.98149C0.862964 4.62129 0.726562 5.30702 0.726562 5.99954Z" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default CheckCircleIcon;